angular.module('jv.Candidate.Feed.Controller', ['infinite-scroll','jv.Common.Directives.HideOnBlur'])
    .controller('jvcandidateFeedController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','$timeout','$window','$q','jvNotesFactory','jvMessagesFactory', 'GAService','jvHireUrlService',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$timeout,$window,$q,jvNotesFactory,jvMessagesFactory, GAService, jvHireUrlService) {
            
            var _pageSize = 5;
            
            //set flag to false on load as its set to true on every routeChange
            $scope.flags.loading = false;
            //settings up params for GET call
            
            //pagination configs
            $scope.currentPage = -1;
            $scope.pageSize = 20;
            $scope.canPaginate  = true;
            $scope.feedMigrationDone = false;
            $scope.feedLoaded = false;
            
            //array to hold candidate feed data
            $scope.candidateFeed = [];

            //feed filter configs
            $scope.postData = {
                applicationId: $scope.applicationId,
                page: $scope.currentPage,
                pageSize: $scope.pageSize,
                allApplications:true
            };

            //default values for the feed filters
            $scope.feedFilterValues = {
                Notes : false,
                Message: false,
                Evaluation: false,
                SharePost: false,
                ShareApplication: false,
                allApplications: true
            };
            $scope.feedFilterDropdown = false;
            $scope.activeFeedFilterCount = 0;

            //setting up feed filter config 
            $scope.feedFilters  = [
                {
                    type: 'check',
                    showCondition: 'true',
                    ngModel:'allApplications',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'allApplications\')',
                    value: 'allApplications',
                    text: i18n['THIS_APPLICATION']
                },
                {
                    type: 'check',
                    showCondition: $scope.perms.APPLICATION_NOTES_GET,
                    ngModel:'Notes',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'Notes\')',
                    value: 'Notes',
                    text: i18n['NOTES']
                },
                {
                    type: 'check',
                    showCondition: $scope.perms.APPLICATION_MESSAGES_GET,
                    ngModel:'Message',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'Message\')',
                    value: 'Message',
                    text: i18n['MESSAGES']
                },
                {
                    type: 'check',
                    showCondition: $scope.perms.INTERVIEW_EVALUATIONS_GET || $scope.perms.VIDEO_ALL_EVALUATIONS,
                    ngModel:'Evaluation',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'Evaluation\')',
                    value: 'Evaluation',
                    text: i18n['EVALUATIONS']
                },
                {
                    type: 'check',
                    showCondition: 'true',
                    ngModel:'SharePost',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'SharePost\')',
                    value: 'SharePost',
                    text: i18n['POSTS']
                },
                {
                    type: 'check',
                    showCondition: 'true',
                    ngModel:'ShareApplication',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'ShareApplication\')',
                    value: 'ShareApplication',
                    text: i18n['APPLICATION_SHARES']
                },
                {
                    type: 'check',
                    showCondition: LIRSCEnabled,
                    ngModel:'InMailMessage',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'InMailMessage\')',
                    value: 'InMailMessage',
                    text: i18n['LINKEDIN_MESSAGE']
                },
                {
                    type: 'check',
                    // eslint-disable-next-line no-undef
                    showCondition: LIRSCEnabled,
                    ngModel:'InMailNote',
                    checkboxClass: ['marginRight10','width-inherit'],
                    labelClass: ['inline'],
                    clickEvent: 'changeFeedFilter(\'InMailNote\')',
                    value: 'InMailNote',
                    text: i18n['LINKEDIN_NOTE']
                 }
            ];

            // adding feedFilters for rendering filters
            $scope.setupFeedFilters = function(filters){
                //create custom 
                var arr = [];
                var filterNo = 0;
                angular.forEach(filters,function(value,key){
                    if(value.showCondition) {
                        var obj = {};
                        obj.value = value.text;
                        obj.action = value.value;
                        obj.isChecked = false;
                        obj.filterNo = filterNo;
                        arr.push(obj);
                        filterNo++;
                    }
                });
                $scope.filtersList = {
                    actionTitle: 'Filter',
                    sortOptions: arr,
                    selectedOption: -1
                };
            };

            $scope.toggleFeedFiltersDropdown = function(){
                $scope.feedFilterDropdown = !$scope.feedFilterDropdown;
            };

            $scope.hideFeedFiltersDropdown = function() {
                $scope.feedFilterDropdown = false;
            }

            $scope.setActivatedFeedFilterCount = function() {
                var activatedCount = 0;
                angular.forEach($scope.filtersList.sortOptions, function(value,key){
                    if(value.isChecked){
                        activatedCount++;
                    }
                });
                $scope.activeFeedFilterCount = activatedCount;
            }

            $scope.setupFeedFilters($scope.feedFilters);  

            //construct feed filter object based on filters applied on the UI
            var constructFeedFilter = function(feedFilterObject){
                var feedFilter = [];
                angular.forEach(feedFilterObject,function(key,filterObj){
                    if(feedFilterObject[filterObj] && filterObj!='allApplications'){
                        feedFilter.push(filterObj);
                    }
                });
                return feedFilter;
            };

            $scope.refreshFeed = function(){
                $rootScope.$emit('refreshFeed');
            };

            //event listener to refresh feed
            $rootScope.$on('refreshFeed',function(event){
                $scope.canPaginate = true;
                $scope.getCandidateFeed(0);
            });
            
            //replace placeholders with actor names
            var replacePlaceHolders = function(placeholder,token,message){
                var actor = angular.copy(placeholder.objectText);
                var toSearch = angular.copy(token);
                var toReplace = angular.copy(actor);
                var messageWithoutTokens = message.split(toSearch).join(toReplace);
                return messageWithoutTokens;
            };

            //get feed icon based on feed type
            var getFeedIcon = function(feedObj){
                var feedIcon;
                switch(feedObj.feedType){
                    case 'Notes':
                        feedIcon = 'icon icon-document';
                    break;
                    case 'Message':
                        feedIcon = 'icon icon-message';
                    break;
                    case 'Evaluation':
                        feedIcon = 'icon icon-grid-view';
                    break;
                    case 'ShareApplication':
                        feedIcon = 'icon icon-share-contact';
                    break;
                    case 'SharePost':
                        feedIcon = 'icon icon-share-post';
                    break;
                    case 'InMailMessage' : 
                    	feedIcon = 'icon icon-linkedin-square-bg';
                    break;
                    case 'InMailNote' : 
                    	feedIcon = 'icon icon-linkedin-square-bg';
                    break;
                    	
                }
                return feedIcon;
            };

            //Massage feed data to remove placeholder tokens 
            var massageFeedData = function(){
                angular.forEach($scope.candidateFeed,function(feedObj,key){
                    var message = feedObj.title;
                        angular.forEach(feedObj.placeholders,function(placeholder,key){
                            var token = '{{'+key+'}}';
                            feedObj.title = replacePlaceHolders(placeholder,token,feedObj.title);
                            feedObj.icon = getFeedIcon(feedObj);
                        });
                });
            };

            //checks if note is editable 
            var isEdittable = function(expandedItem) {
                return jvNotesFactory.isEdittable(expandedItem);
            };

            //checks if note is replyable 
            var isReplyable = function(expandedItem,type){
                if(type ==='Message'){
                    return jvMessagesFactory.isReplyable(expandedItem);
                }else{
                    return isNoteReplyable(expandedItem);
                }
                
            };

            var isNoteReplyable = function(expandedItem){
                if(expandedItem.to){
                    for(var i = 0; i< expandedItem.to.length; i++){
                        return jvNotesFactory.isReplyable(expandedItem,expandedItem.to[i]);
                    }
                }else{
                    return false;
                }
            };

            var isLoggedInUserInCC = function(ccList){
                var loggedInUserInCC = false;
                angular.forEach(ccList,function(ccUser,key){
                    if(ccUser.EId === $window.jvUser){
                        loggedInUserInCC = true;
                    }
                });
                return loggedInUserInCC;
            };
            //edit note
            $scope.editNote = function(noteObj){
                jvNotesFactory.editNote(noteObj);
            };

            //call to get candidate feed
            //pass noLoading in case spinner should not be displayed. 
            //This is used when migrating feed data message is displayed. 
            $scope.getCandidateFeed = function(pageNumber, noLoading){
                if($scope.canPaginate && !$scope.fetchingFeed){
                    var replaceFeedContent = false;
                    if(pageNumber === 0){
                        replaceFeedContent = true;
                    }
                    $scope.currentPage = $scope.postData.page = pageNumber;
                    if (!noLoading) {
                        $scope.flags.loading = true;
                    }
                    var postData = angular.copy($scope.postData);
                    $scope.fetchingFeed = true;
                    jvCandidatesService.getCandidateFeed(postData,function(response){
                        if(response.data && response.status ===200){
                            $scope.flags.loading = false;
                            $scope.fetchingFeed = false;
                            $scope.feedLoaded = true;
                            if (response.data.feeds.status === 'IN_PROGRESS') {
                                $scope.feedMigrationDone = false;
                                $timeout(function() {
                                    $scope.getCandidateFeed(0, true);
                                }, response.data.feeds.timerInMilliseconds);
                                return;
                            } else {
                                $scope.feedMigrationDone = true;
                            }
                            $scope.feedCount = response.data.feeds.feedCount;
                            $scope.totalCount = angular.copy($scope.feedCount);
                            if(!response.data.feeds.feedViews && response.data.feeds.feedCount === 0){
                                $scope.noFeedData = $scope.currentPage === 0 ? true: false;
                                if(replaceFeedContent){
                                    $scope.candidateFeed = [];
                                }
                                return;
                            }
                            //Replace the feed content anytime a new filter is applied
                            if(replaceFeedContent){
                                $scope.candidateFeed  =  response.data.feeds.feedViews;
                            }else{
                                //else you append to the feed data
                                $scope.candidateFeed  =  $scope.candidateFeed.concat(response.data.feeds.feedViews);
                            }
                            
                            checkForLikes($scope.candidateFeed);
                            
                            $scope.noFeedData = false;
                            if($scope.feedCount){
                                massageFeedData();
                            }
                            $scope.flags.loading = false;
                            $scope.maxPageNumber = Math.round($scope.totalCount/$scope.pageSize);
                            var nextPage = (pageNumber+1);
                            $scope.canPaginate = (  nextPage < $scope.maxPageNumber ) ? true: false;
                        }else{
                            $scope.flags.loading = false;
                        }
                    });
                }
            };

            $scope.getCandidateFeed(0);

            //message reply
            $scope.replyMessage = function(feedItem){
                jvMessagesFactory.replyMessage(feedItem);
            };

            //note reply 
            $scope.replyNote = function(feedItem){
                jvNotesFactory.replyNote(feedItem);
            };

            //delete Note from the activity feed
            $scope.deleteNote = function(noteObj){
                var noteObject = {
                    applicationId: $scope.applicationId,
                    id: noteObj.objectEId
                };
                $scope.flags.loading = true;
                jvNotesFactory.deleteNote(noteObject,function(response){
                    if(response && response.msgInfo === 200){
                        $scope.flags.loading = false;
                        $scope.toggleFeedItem(noteObj);
                        $rootScope.$emit('refreshFeed');
                        $rootScope.$emit('updateNoteCount');
                    }
                });
            };

            var checkForLikes = function(feeds){       
                for(var i = 0; i<feeds.length; i++){
                    var feed = feeds[i];
                    feed.likedByMe = false;
                    if(feed.likes){
                        for(var j = 0; j<feed.likes.length; j++){
                            var like = feed.likes[j];
                            if(like.actor.actorEId === $window.jvUser){
                                feed.likedByMe = true;
                            }
                        }
                    }
                }
            };
            
            var fetchSharedUsers = function(feedObj){
                var deferred = $q.defer();
                var data = {
                     ids: feedObj.participantEIds.join(',')
                };
                jvCandidatesService.userSearch(data,function(response){
                    if(response.data && response.status === 200){
                        $scope.flags.loading = false;
                        deferred.resolve(response);
                    }else{
                        $scope.flags.loading = false;
                    }
                });
                return deferred.promise;
            };
            
            // call to fetch feed details
            var fetchFeedDetails = function(feedObj){
                var deferred = $q.defer();
                var postData = {
                     applicationId: feedObj.targetEId,
                     objectEId: feedObj.objectEId
                };
                jvCandidatesService.fetchFeedDetail(postData,function(response){
                    if(response.data && response.status ===200){
                        deferred.resolve(response);
                    }else{
                        $scope.flags.loading = false;
                    }
                });
                return deferred.promise;
            };

            //handler for feed fiters
            $scope.changeFeedFilter = function(feedFilter){
                //No need to internationalize
                var eventGA = 'FeedFilter:' +feedFilter;
                GAService.track(eventGA);
                $scope.feedFilterValues[feedFilter] = !$scope.feedFilterValues[feedFilter];
                $scope.postData.feedType = constructFeedFilter($scope.feedFilterValues);
                $scope.postData.allApplications = $scope.feedFilterValues.allApplications;
                $scope.canPaginate = true;
                $scope.getCandidateFeed(0);

                // set the checked filter count
                $scope.setActivatedFeedFilterCount();
            };

            $scope.checkFeedFilter = function(feedFilter, filterNo){
                $scope.filtersList.sortOptions[filterNo].isChecked = !$scope.filtersList.sortOptions[filterNo].isChecked;
                $scope.changeFeedFilter(feedFilter);
            };

            //expand/collapse feed item
            $scope.toggleFeedItem = function(feedItem){
                if(!feedItem.expanded){
                    $scope.flags.loading = true;
                    if(feedItem.feedType === 'ShareApplication'){
                        fetchSharedUsers(feedItem).then(function(response){
                            feedItem.expanded = !feedItem.expanded;
                            feedItem.sharedEmployees = response.data.employees;
                            $scope.flags.loading = false;
                        });
                    } else if (feedItem.feedType === 'SharePost' || feedItem.feedType === 'InMailMessage' || feedItem.feedType === 'InMailNote'){
                        feedItem.expanded = !feedItem.expanded;
                        $scope.flags.loading = false;
                    } else{
                        fetchFeedDetails(feedItem).then(function(response){
                            var expandedFeedItem = response.data.messageDataItem[0];
                            feedItem.isEdittable = isEdittable(expandedFeedItem);
                            feedItem.expanded = !feedItem.expanded;
                            feedItem.from = expandedFeedItem.from;
                            if(feedItem.feedType === 'Notes'){
                                feedItem.noteToList = expandedFeedItem.to;
                                feedItem.isNoteReplyable = isReplyable(expandedFeedItem,feedItem.feedType);
                            }
                            if(feedItem.feedType === 'Message'){
                                feedItem.messageToList = expandedFeedItem.to;
                                feedItem.messagecc = expandedFeedItem.cc;
                                feedItem.isMessageReplyable = isReplyable(expandedFeedItem,feedItem.feedType);
                                feedItem.isLoggedInUserInCC = isLoggedInUserInCC(expandedFeedItem.cc);
                                //if logged in user is in the cc list of a message and hits reply, that should be a note reply because its internal.
                                if(feedItem.isLoggedInUserInCC){
                                    feedItem.isMessageReplyable = false;
                                    feedItem.isNoteReplyable = true;
                                }
                            }
                            feedItem.attachments = expandedFeedItem.attachments;
                            $scope.flags.loading = false;
                        });
                    }
                }else{
                    feedItem.expanded = !feedItem.expanded;
                }
            };
            
            $scope.addPost = function(){
                $scope.flags.quickForms = 'post';
                $scope.showQForm('post');
            };
            
            // like a feed
            var likeFeed = function(feed, isLiked){
                var postData = {
                    targetEId:feed.targetEId,
                    feedOid:feed.feedOid
                };
                jvCandidatesService.likeFeed(postData,function(response){
                    if(response && response.data){
                        feed.likes = feed.likes || [];
                        if(isLiked){
                            feed.likes.push(response.data.like);
                        }else{
                            var pos = -1;
                            for(var i=0; i<feed.likes.length; i++){
                                if(feed.likes[i].actor.actorEId === $window.jvUser){
                                    pos = i;
                                    break;
                                }
                            }
                            if(pos >= 0){
                                feed.likes.splice(pos, 1);
                            }
                        }
                    }
                });
            };

            $scope.toggleFeedLike = function(feed){
                feed.likedByMe = !feed.likedByMe;
                likeFeed(feed, feed.likedByMe);
            };

            // comment on a feed
            $scope.commentFeed = function(feed){
                var postData = {
                    targetEId:feed.targetEId,
                    feedOid:feed.feedOid,
                    comment:feed.commentText
                };
                feed.commentText = '';
                jvCandidatesService.commentFeed(postData,function(response){
                    feed.comments = feed.comments || [];
                    if(response && response.data){
                        feed.comments.push(response.data.comment);
                        feed.commentsTotalCount++;
                    }
                });

            };
            
            $scope.deleteComment = function(comment, feedItem, pos){
                var data = {
                    applicationEId: feedItem.targetEId,
                    feedOid: feedItem.feedOid,
                    commentOid: comment.objectId
                };
                
                jvCandidatesService.deleteComment(data, function(res){
                    if(res && res.data){
                        if(res.data.msgInfo === 1){
                            feedItem.comments.splice(pos, 1);
                            feedItem.commentsTotalCount--;
                        }
                    }
                });
            };

            // cancel comment on feed
            $scope.cancelComment  = function(feed){
                feed.commentText = '';
            };
            
            // view more comments by page
            $scope.showPreviousComments = function(feedItem){
                var data = {
                    applicationEId: feedItem.targetEId,
                    feedOid: feedItem.feedOid,
                    pageSize: _pageSize,
                    offset: feedItem.comments.length
                };
                
                jvCandidatesService.getComments(data, function(res){
                    if(res.data && res.data.feed && res.data.feed.comments && res.data.feed.comments.length > 0 ){
                        for(var i=res.data.feed.comments.length-1; i>=0; i--){
                            feedItem.comments.unshift(res.data.feed.comments[i]);
                        }
                    }
                });
            };
            
            $scope.startTyping = function(feedItem, event){
                feedItem.focus = true;
                // dirty fix . either create a directive or change the requirement
                $timeout(function () {
                    $(event.target).parent().parent().siblings('.commentBox').children('.commentData').focus();
                },0);
            };

            // check whether to SHOW_MORE
            $scope.displayShowMore = function(feedItem){
                var display = false;
                // eslint-disable-next-line no-undefined
                var commentsExists = !(feedItem.content === undefined || feedItem.content === null);
                var commentsOversize = false;
                if (commentsExists) {
                    commentsOversize = (feedItem.content.length > 100);
                }
                

                switch(feedItem.feedType) {
                    case 'ShareApplication' :
                        display = true;
                        break;
                    case 'SharePost' :
                        display = commentsOversize;
                        break;
                    case 'Evaluation' :
                        display = false;
                        break;
                    default :
                        display = commentsExists;
                }
                return !feedItem.expanded && display;
            };

            $scope.goToCandidateDetails = function(feedItem){
                jvHireUrlService.reloadCandidateDetails('/evaluations/{0}/list/{1}/{2}'.format(feedItem.targetEId,feedItem.objectEId,feedItem.secondaryObjectEId));
            };
        }
]);